export default {
  prescriptions: {
    title: 'Prescription Management',
    subtitle: 'Validation and supervision of medical prescriptions',
    refresh: 'Refresh',
    filters: {
      search: 'Search',
      searchPlaceholder: 'Patient, doctor, medication...',
      status: 'Status',
      statusAll: 'All Statuses',
      priority: 'Priority',
      priorityAll: 'All Priorities',
      controlled: 'Controlled Substance',
      controlledAll: 'All',
      yes: 'Yes',
      no: 'No'
    },
    table: {
      prescription: 'Prescription',
      patient: 'Patient',
      doctor: 'Doctor',
      priority: 'Priority',
      status: 'Status',
      controlled: 'Controlled',
      date: 'Date',
      actions: 'Actions',
      loading: 'Loading prescriptions...',
      noResults: 'No prescriptions found',
      controlledTooltip: 'Controlled substance',
      uncontrolledTooltip: 'Uncontrolled substance',
      createdAt: 'Created on {{date}}',
      viewDetails: 'View Details',
      validate: 'Validate Prescription',
      cancel: 'Cancel Prescription'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      showing: 'Showing {{start}} to {{end}} of {{total}} results',
      pageOf: 'Page {{page}} of {{totalPages}}'
    },
    statusNames: {
      DRAFT: 'Draft',
      ACTIVE: 'Active',
      FILLED: 'Filled',
      CANCELLED: 'Cancelled',
      EXPIRED: 'Expired'
    },
    priorityNames: {
      LOW: 'Low',
      NORMAL: 'Normal',
      HIGH: 'High',
      URGENT: 'Urgent'
    },
    stats: {
      total: 'Total Prescriptions',
      controlled: 'Controlled Substances',
      renewable: 'Renewable Prescriptions',
      emergencies: 'Emergencies'
    }
  },
  consultations: {
    filters: {
      search: 'Search',
      searchPlaceholder: 'Patient, doctor, symptoms...',
      status: 'Status',
      statusAll: 'All Statuses',
      urgency: 'Urgency',
      urgencyAll: 'All Urgencies',
      dateFrom: 'Start Date',
      statusNames: {
        PENDING: 'Pending',
        SCHEDULED: 'Scheduled',
        IN_WAITING_ROOM: 'In Waiting Room',
        IN_PROGRESS: 'In Progress',
        COMPLETED: 'Completed',
        CANCELLED: 'Cancelled'
      },
      urgencyNames: {
        NORMAL: 'Normal',
        URGENT: 'Urgent',
        EMERGENCY: 'Emergency',
        CRITICAL: 'Critical'
      }
    },
    table: {
      date: 'Date',
      patient: 'Patient',
      doctor: 'Doctor',
      urgency: 'Urgency',
      status: 'Status',
      prescription: 'Prescription',
      actions: 'Actions',
      loading: 'Loading consultations...',
      noResults: 'No consultations found',
      noPrescription: 'None'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      showing: 'Showing {{start}} to {{end}} of {{total}} results',
      pageOf: 'Page {{page}} of {{totalPages}}'
    },
    details: {
      title: 'Consultation Details {{number}}',
      close: 'Close',
      generalInfo: 'General Information',
      status: 'Status:',
      urgency: 'Urgency:',
      date: 'Date:',
      type: 'Type:',
      participants: 'Participants',
      patient: 'Patient',
      doctor: 'Doctor',
      medicalInfo: 'Medical Information',
      symptoms: 'Symptoms',
      diagnosis: 'Diagnosis',
      recommendations: 'Recommendations',
      medicalQuestion: 'Medical Question',
      prescriptionTitle: 'Prescription',
      medication: 'Medication',
      priority: 'Priority',
      associatedAppointment: 'Associated Appointment',
      id: 'ID',
      cancel: {
        title: 'Cancel Consultation',
        confirmText: 'Are you sure you want to cancel the consultation for {{patient}} with Dr. {{doctor}}?',
        reasonLabel: 'Reason for Cancellation',
        reasonPlaceholder: 'Explain the reason for this cancellation...',
        btnCancel: 'Cancel',
        btnConfirm: 'Confirm Cancellation',
        btnPending: 'Cancelling...'
      },
      priorityChange: {
        title: 'Change Priority',
        infoText: 'Consultation for {{patient}} with Dr. {{doctor}}',
        newPriorityLabel: 'New Priority',
        priorityLow: 'Low',
        priorityNormal: 'Normal',
        priorityHigh: 'High',
        reasonLabel: 'Reason for Change',
        reasonPlaceholder: 'Explain the reason for this change...',
        btnCancel: 'Cancel',
        btnConfirm: 'Change Priority',
        btnPending: 'Updating...'
      }
    },
    stats: {
      total: 'Total Consultations',
      recent: 'Recent Consultations',
      avgDuration: 'Avg Duration',
      emergencies: 'Emergencies'
    },
    moderation: {
      loading: 'Loading Moderation...',
      title: 'Consultations to Moderate',
      realTime: 'Real-Time',
      moderationTag: 'Moderation',
      allBtn: 'All',
      urgentBtn: 'Urgent',
      refreshBtn: 'Refresh',
      stats: {
        total: 'Total',
        inProgress: 'In Progress',
        critical: 'Critical',
        interventions: 'Interventions'
      },
      bulk: {
        selected: '{{count}} selected',
        cancelBtn: 'Bulk Cancel',
        deselectBtn: 'Deselect',
        promptReason: 'Reason for bulk cancellation of {{count}} consultations:'
      },
      table: {
        titleUrgent: 'Critical Consultations',
        titleAll: 'Consultations to Moderate',
        entries: '{{count}} entries',
        selectLabel: 'Select consultation {{id}}',
        symptoms: 'Symptoms:',
        actions: {
          cancel: 'Cancel',
          pause: 'Pause',
          escalate: 'Escalate',
          resume: 'Resume',
          forceComplete: 'Force Complete'
        },
        noResults: 'No consultations to moderate',
        promptCancelReason: 'Reason for cancellation:',
        promptInterventionReason: 'Reason for intervention ({{action}}):'
      }
    }
  },
  notifications: {
    broadcast: {
      title: 'General Broadcast',
      live: 'Live',
      titleLabel: 'Notification Title',
      titlePlaceholder: 'Broadcast title',
      messageLabel: 'Message',
      messagePlaceholder: 'Notification content',
      typeLabel: 'Type',
      priorityLabel: 'Priority',
      rolesLabel: 'Target Roles',
      byRoles: 'By Roles',
      byUsers: 'Users',
      usersPlaceholder: 'User IDs (comma separated)',
      expirationLabel: 'Expiration (days)',
      btnBroadcast: 'Launch Broadcast',
      btnPending: 'Broadcasting...'
    },
    types: {
      SYSTEM_NOTIFICATION: 'System Notification',
      APPOINTMENT_REMINDER: 'Appointment Reminder',
      MESSAGE_RECEIVED: 'Message Received',
      TELECONSULTATION_STARTED: 'Teleconsultation Started',
      PRESCRIPTION_CREATED: 'Prescription Created',
      PRESCRIPTION_READY: 'Prescription Ready',
      PRESCRIPTION_EXPIRED: 'Prescription Expired'
    },
    priorities: {
      LOW: 'Low',
      NORMAL: 'Normal',
      HIGH: 'High',
      URGENT: 'Urgent'
    },
    registry: {
      title: 'Notification Registry',
      entriesCount: '{{count}} entries',
      searchPlaceholder: 'Search notification...',
      typeAll: 'All Types',
      typeSystem: 'System',
      typeReminder: 'Appointment Reminder',
      typeMessage: 'Message',
      typePrescription: 'Prescription',
      btnNew: 'New Notification',
      table: {
        notification: 'Notification',
        recipient: 'Recipient',
        type: 'Type',
        status: 'Status',
        date: 'Date',
        actions: 'Actions',
        loading: 'Loading...',
        noResults: 'No notifications',
        read: 'Read',
        unread: 'Unread',
        viewDetails: 'View Details',
        delete: 'Delete',
        deleteConfirm: 'Are you sure you want to delete this notification?'
      },
      details: {
        title: 'Notification Details',
        close: 'Close',
        notificationTitle: 'Title',
        message: 'Message',
        type: 'Type',
        status: 'Status',
        recipient: 'Recipient',
        role: 'Role: {{role}}',
        createdAt: 'Created at',
        readAt: 'Read at',
        expiresAt: 'Expires at',
        extraData: 'Extra Data'
      },
      create: {
        title: 'New Notification',
        btnCancel: 'Cancel',
        btnConfirm: 'Create Notification',
        btnPending: 'Creating...'
      }
    },
    templates: {
      name: 'Template',
      subject: 'Subject',
      content: 'Content',
      variables: 'Variables'
    },
    createSuccess: 'Notification created successfully',
    broadcastSuccess: 'Broadcast started successfully',
    deleteSuccess: 'Notification deleted successfully',
    loadError: 'Error loading communications',
    consoleSecure: 'Secure Console',
    systemTitle: 'System Communications',
    refreshBtn: 'Refresh',
    tabNotifications: 'Notifications',
    tabTemplates: 'Templates',
    tabBroadcast: 'Broadcast'
  },
  permissions: {
    searchPlaceholder: 'Search permissions...',
    categoryAll: 'All Categories',
    noResults: 'No permissions found',
    resource: 'Resource',
    action: 'Action',
    description: 'Description',
    id: 'ID',
    roleAssignedSuccess: 'Role assigned successfully',
    checkSuccess: 'Verification completed',
    loadError: 'Error loading permissions',
    title: 'Permissions Management',
    subtitle: 'Access control and user roles management',
    refresh: 'Refresh',
    tabRoles: 'Roles',
    tabPermissions: 'Permissions',
    tabUsers: 'Users',
    tabAudit: 'Audit',
    rolesList: {
      title: 'System Roles',
      subtitle: 'Roles and permissions management',
      colRole: 'Role',
      colDescription: 'Description',
      colPermissions: 'Permissions',
      colUsers: 'Users',
      colSystem: 'System',
      colActions: 'Actions',
      loading: 'Loading roles...',
      noRoles: 'No roles found',
      viewDetails: 'View details',
      assignRole: 'Assign role',
      detailsTitle: 'Role Details: {{name}}',
      infoTitle: 'General Information',
      nameLabel: 'Name:',
      usersLabel: 'Users:',
      systemRoleLabel: 'System Role:',
      yes: 'Yes',
      no: 'No',
      descLabel: 'Description',
      permissionsTitle: 'Permissions ({{count}})',
      assignTitle: 'Assign Role: {{name}}',
      assignDesc: 'Enter the ID of the user to assign this role to',
      userIdLabel: 'User ID',
      userIdPlaceholder: 'Enter user ID',
      reasonLabel: 'Reason',
      reasonPlaceholder: 'Explain the reason for this change...',
      cancelBtn: 'Cancel',
      assignBtn: 'Assign',
      assignPending: 'Assigning...'
    },
    auditList: {
      title: 'Permissions Audit',
      subtitle: 'History of role and permission changes',
      colAction: 'Action',
      colUser: 'User',
      colTarget: 'Target',
      colDetails: 'Details',
      colDate: 'Date',
      loading: 'Loading audit logs...',
      noLogs: 'No audit logs found'
    }
  },
  settings: {
    title: 'Account Settings',
    subtitle: 'Manage your personal information and the security of your administrator access',
    profileTab: 'Public Profile',
    securityTab: 'Security',
    notificationsTab: 'Notifications',
    adminLevel: 'Administrator Level',
    adminLevelDesc: 'Your account benefits from enhanced protection and extended system privileges.',
    mfaActive: 'MFA Active',
    adminProfile: 'Administrator Profile',
    fullName: 'Full name',
    proEmail: 'Professional email',
    saveChanges: 'Save changes',
    accountSecurity: 'Account Security',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNew: 'Confirm new password',
    changePasswordWarning: 'Changing your password will invalidate all your active sessions on other devices for security reasons.',
    updateSecurity: 'Update security',
    profileSuccess: 'Profile updated successfully',
    profileError: 'Error updating profile',
    passwordsMismatch: 'Passwords do not match',
    passwordSuccess: 'Password changed successfully',
    passwordError: 'Error changing password'
  },
  users: {
    title: 'Advanced User Management',
    subtitle: 'Complete administration of user accounts',
    filters: 'Filters',
    refresh: 'Refresh',
    tabUsers: 'Users',
    tabStats: 'Statistics',
    tabBulk: 'Bulk Actions',
    bulkActions: 'Bulk Actions',
    selectedUsers: '{{count}} user(s) selected',
    bulkProcessedSuccess: '✅ {{count}} user(s) processed successfully',
    bulkProcessedErrors: '⚠️ {{count}} error(s)',
    close: 'Close',
    bulkSuccess: 'Bulk action executed successfully',
    activateSuccess: 'User activated successfully',
    deactivateSuccess: 'User deactivated successfully',
    deleteSuccess: 'User deleted successfully',
    verifySuccess: 'User verified successfully',
    selectAtLeastOne: 'Please select at least one user',
    provideReason: 'Please provide a reason for this action',
    exportError: 'Error during export',
    neverConnected: 'Never connected',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{{count}} days ago',
    weeksAgo: '{{count}} weeks ago',
    monthsAgo: '{{count}} months ago',
    loadError: 'Error loading user management',
    confirmDeleteTitle: 'Confirm Delete',
    confirmDeleteDesc: 'Are you sure you want to delete {{name}}?',
    cancel: 'Cancel',
    delete: 'Delete',
    changeRoleTitle: 'Change Role of {{name}}',
    currentRole: 'Current Role:',
    newRole: 'New Role',
    confirm: 'Confirm',
    roles: {
      PATIENT: 'Patient',
      DOCTOR: 'Doctor',
      ADMIN: 'Administrator'
    },
    statistics: {
      totalUsers: 'Total Users',
      activeUsers: 'Active Users',
      verifiedUsers: 'Verified Users',
      newUsers7d: 'New (7d)',
      byRole: 'Role Distribution',
      registrationTrends30d: 'Registrations (Last 30 Days)',
      activityMetrics: 'Activity Metrics',
      totalSessions: 'Total Sessions',
      activeUsers7d: 'Active (7d)',
      activeUsers30d: 'Active (30d)',
      avgSessionDuration: 'Average Duration'
    }
  },
  security: {
    critError: 'Critical failure of the security module',
    controlCenter: 'Control Center',
    security: 'Security',
    refresh: 'Refresh',
    fullAudit: 'Full Audit',
    apiResponseTime: 'API Response Time',
    stable: 'Stable',
    cpuLoad: 'CPU Load',
    storageStatus: 'Storage Status',
    nodesActive: 'Nodes Active',
    ipAccessRestored: 'Access restored for IP',
    ipBlockedSuccess: 'Secured perimeter: IP blocked',
    ruleActivated: 'Protection rule activated',
    threatIntel: 'Threat Intelligence',
    shielding: 'Shielding (Rate Limit)',
    quantumFirewall: 'Quantum Firewall',
    auditForensic: 'Audit Forensic',
    dataIntegrity: 'Data Integrity',
    optimal: 'Optimal',
    normal: 'Normal',
    synced: 'Synced',
    forensicData: 'Forensic Data',
    generalInfo: 'General Info',
    eventType: 'Event Type',
    severity: 'Severity',
    ipSource: 'IP Source',
    networkVector: 'Network Vector',
    rawPayload: 'Raw Details Payload',
    protectionAction: 'Protection Action',
    requestIntercepted: 'Request intercepted and filtered.',
    firewallTitle: 'Firewall & IP Blocking',
    firewallSubtitle: 'Management of blocked IP addresses and firewall rules',
    blockIPBtn: 'Block IP',
    thIPAddress: 'IP Address',
    thReason: 'Reason',
    thBlockedAt: 'Blocked at',
    thExpiresAt: 'Expires at',
    thActions: 'Actions',
    loadingBlockedIPs: 'Loading blocked IPs...',
    permanent: 'Permanent',
    noBlockedIPs: 'No blocked IPs',
    unblockIPTooltip: 'Unblock',
    totalRequests: 'Total Requests',
    blocked: 'Blocked',
    authAttempts: 'Auth Attempts',
    successful: 'Successful',
    failed: 'Failed',
    suspiciousActivity: 'Suspicious Activity',
    lockedAccounts: 'Locked Accounts',
    bruteForce: 'Brute force',
    attempts: 'attempts',
    topBlockedEndpoints: 'Top Blocked Endpoints',
    blocks: 'blocks',
    topCountries: 'Top Countries',
    requests: 'requests',
    quickActions: 'Quick Actions',
    createRateLimit: 'Create Rate Limit',
    limitRequestsByEndpoint: 'Limit requests by endpoint',
    blockIP: 'Block IP',
    blockSuspiciousIP: 'Block a suspicious IP address',
    viewLogs: 'View Logs',
    consultSecurityLogs: 'Consult security logs',
    newRule: 'New Rule',
    rule: 'Rule',
    window: 'Window',
    status: 'Status',
    loadingRules: 'Loading rules...',
    enabled: 'Enabled',
    disabled: 'Disabled',
    modify: 'Modify',
    delete: 'Delete',
    noRateLimits: 'No rate limiting rules',
    inputValidation: 'Input Validation',
    validationRulesDesc: 'Validation rules to secure user input',
    field: 'Field',
    valueLabel: 'Value',
    errorMessage: 'Error Message',
    noValidationRules: 'No validation rules',
  },
  dataExport: {
    exportsTitle: 'Data Exports',
    exportsDesc: 'Export system data in different formats',
    newExport: 'New Export',
    configsTitle: 'Export Configurations',
    loadingConfigs: 'Loading configurations...',
    runBtn: 'Run',
    noConfigs: 'No export configurations',
    backupsTitle: 'System Backups',
    backupsDesc: 'Manage automatic and manual backups',
    cleanBtn: 'Cleanup',
    restoreBtn: 'Restore',
    newBackupBtn: 'New Backup',
    configsBackupTitle: 'Backup Configurations',
    statusIdle: 'Idle',
    statusRunning: 'Running',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    noBackupConfigs: 'No backup configurations',
    totalBackups: 'Total Backups',
    successful: 'Successful',
    failed: 'Failed',
    totalSize: 'Total Size',
    historyTitle: 'Backup History',
    backup: 'Backup',
    size: 'Size',
    started: 'Started',
    duration: 'Duration',
    actions: 'Actions',
    loadingHistory: 'Loading history...',
    noHistory: 'No backups in history',
    viewDetails: 'View details',
    download: 'Download',
    jobDetails: 'Job Details',
    progress: 'Progress',
    error: 'Error',
    tables: 'Tables',
    restoreCrit: '⚠️ Critical Restore',
    restoreWarning: 'This operation will overwrite all current data. Make sure you have a recent backup.',
    backupIdLabel: 'Backup ID',
    targetDbLabel: 'Target database (optional)',
    irreversibleWarning: '⚠️ This action is IRREVERSIBLE and will overwrite all current data.',
    confirmRestore: 'Confirm Restore',
    cancel: 'Cancel',
    status: {
      PENDING: 'Pending',
      RUNNING: 'Running',
      COMPLETED: 'Completed',
      FAILED: 'Failed'
    },
    format: {
      CSV: 'CSV',
      JSON: 'JSON',
      PDF: 'PDF',
      EXCEL: 'Excel'
    },
    restoringBtn: 'Restoring...'
  },
  systemMonitoring: {
    metric: 'Metric',
    threshold: 'Threshold',
    currentValue: 'Current Value',
    triggeredAt: 'Triggered',
    close: 'Close',
    acknowledging: 'Acknowledging...',
    acknowledge: 'Acknowledge',
    alertsTitle: 'System Alerts',
    refreshBtn: 'Refresh',
    noAlerts: 'No active alerts',
    databaseTitle: 'Database',
    total: 'Total',
    active: 'Active',
    inactive: 'Inactive',
    slowQueries: 'Slow queries',
    avgQueryTime: 'Average time',
    apiTitle: 'API',
    successful: 'Successful',
    failed: 'Failed',
    avgResponseTime: 'Average response time',
    mostUsedEndpoints: 'Most Used Endpoints',
    endpoint: 'Endpoint',
    method: 'Method',
    requests: 'Requests',
    avgTime: 'Average Time',
    errorRate: 'Error Rate',
    enableMaintenance: 'Enable Maintenance',
    disableMaintenance: 'Disable Maintenance',
    enableMaintenanceDesc: 'This will notify users that the system is down for maintenance.',
    disableMaintenanceDesc: 'This will restore normal system access.',
    maintenanceMessageLabel: 'Maintenance message',
    maintenanceMessagePlaceholder: 'Message to show to users...',
    estimatedDurationLabel: 'Estimated duration (minutes)',
    cancelBtn: 'Cancel',
    applyingBtn: 'Applying...',
    confirmBtn: 'Confirm',
    cpuTitle: 'Processor',
    usageLabel: 'Usage',
    coresLabel: 'Cores',
    loadAverageLabel: 'Load average',
    memoryTitle: 'Memory',
    totalLabel: 'Total',
    usedLabel: 'Used',
    freeLabel: 'Free',
    diskTitle: 'Storage',
    systemInfoTitle: 'System Information',
    platformLabel: 'Platform',
    archLabel: 'Architecture',
    nodeVersionLabel: 'Node.js',
    uptimeLabel: 'Uptime',
    lastUpdateLabel: 'Last update',
    networkInterfacesTitle: 'Network Interfaces',
    interfaceLabel: 'Interface',
    ipAddressLabel: 'IP Address',
    macAddressLabel: 'MAC Address',
    healthTitle: 'Overall Health Status',
    healthHealthy: 'Healthy',
    healthWarning: 'Warning',
    healthCritical: 'Critical',
    maintenanceBtn: 'Maintenance',
    uptimeDesc: 'Uptime',
    versionLabel: 'Version',
    responseTimeDesc: 'Response time',
    lastCheckDesc: 'Last check',
    externalServicesLabel: 'External Services',
    latencyLabel: 'Latency',
    cpuDesc: 'CPU',
    diskDesc: 'Disk',
    activeAlertsTitle: 'Active Alerts ({{count}})',
    viewAllAlertsLink: 'View all alerts →',
    loading: 'Loading real-time monitoring...',
    realtimeTitle: 'Real-Time Monitoring',
    subtitle: 'EKOSE - Live system surveillance',
    lastUpdate: 'Last update:',
    userStatsTitle: 'User Statistics',
    totalUsers: 'Total Users',
    doctors: 'Doctors',
    patients: 'Patients',
    online: 'Online',
    systemPerfTitle: 'System Performance',
    systemServicesTitle: 'System Services',
    recentActivityTitle: 'Recent Activity',
    noRecentActivity: 'No recent activity',
    maintenanceDefaultMessage: 'The system is undergoing maintenance. We apologize for any inconvenience caused.',
    alertAckSuccess: 'Alert acknowledged successfully',
    maintenanceEnabledSuccess: 'Maintenance mode enabled',
    maintenanceDisabledSuccess: 'Maintenance mode disabled',
    loadError: 'Error loading system monitoring data',
    title: 'System Monitoring',
    subtitleSystem: 'Real-time infrastructure and application surveillance',
    tabOverview: 'Overview',
    tabSystem: 'System',
    tabApplication: 'Application',
    tabAlerts: 'Alertes',
    tabLogs: 'Logs',
    logsTitle: 'System Logs',
    logsPlaceholder: 'Logs feature to be implemented'
  },
  services: {
    loading: 'Loading services...',
    loadError: 'Error loading services status',
    toggleError: 'Error updating service status',
    toggleSuccessReason: 'Service re-activated',
    toggleFailReason: 'Planned maintenance',
    title: 'Services Management',
    subtitle: 'Infrastructure',
    maintenanceModeTag: 'Maintenance Mode',
    refreshBtn: 'Refresh',
    retryBtn: 'Retry',
    maintenanceBtn: 'Maintenance',
    disableBtn: 'Disable',
    kpi: {
      active: 'Active Services',
      inactive: 'Inactive Services',
      lastMaintenance: 'Last Maintenance',
      none: 'None'
    },
    table: {
      title: 'Services ({{count}})',
      lastMaintenanceLabel: 'Last maintenance: {{date}}',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      btnActivate: 'Activate',
      btnDeactivate: 'Disable',
      cannotDisable: 'This service cannot be disabled',
      names: {
        database: 'Database',
        redis: 'Redis Cache',
        email: 'Email Service',
        notifications: 'Notifications'
      },
      descriptions: {
        database: 'PostgreSQL Database',
        redis: 'Redis Cache',
        email: 'Email Delivery Service',
        notifications: 'Notification Service'
      }
    },
    modal: {
      enableTitle: 'Enable Maintenance',
      disableTitle: 'Disable Maintenance',
      enableDesc: 'Users will see a maintenance message during this time.',
      disableDesc: 'Services will be accessible again to all users.',
      reasonLabel: 'Reason (optional)',
      reasonPlaceholder: 'Reason for maintenance...',
      cancelBtn: 'Cancel',
      activateBtn: 'Enable',
      reactivateBtn: 'Re-enable'
    }
  },
  doctors: {
    title: 'Doctors Management',
    subtitle: 'Manage doctors on the EKOSE-RX platform',
    refresh: 'Refresh',
    searchPlaceholder: 'Search by name, email, specialty, city...',
    stats: '{{count}} doctor(s) found out of {{total}} total',
    table: {
      name: 'Name',
      email: 'Email',
      speciality: 'Specialty',
      city: 'City',
      status: 'Status',
      createdAt: 'Created at',
      actions: 'Actions'
    },
    noResults: 'No doctors found',
    noResultsHint: 'Try changing your search criteria',
    generalist: 'General Practitioner',
    viewDetails: 'View Details',
    approve: 'Approve',
    suspend: 'Suspend',
    delete: 'Delete',
    features: {
      suspendUnavailable: 'Suspension feature coming soon',
      approveSuccess: 'Doctor successfully approved',
      deleteSuccess: 'Doctor successfully deleted',
      deleteConfirm: 'Are you sure you want to delete this doctor?'
    },
    errors: {
      loadError: 'Error loading doctors'
    },
    statusNames: {
      ACTIVE: 'Active',
      PENDING: 'Pending',
      SUSPENDED: 'Suspended',
      INACTIVE: 'Inactive'
    }
  }
};
